import { getSignedURL, uploadAudioFile } from "../../../Client/request";
import { S3_BASE_URL } from "../../../Client/apiURL";

export const processAudioUpload = async (recordedBlobFile) => {
  if (!recordedBlobFile) return null;
  
  try {
    const signedUrlRes = await getSignedURL();
    if (signedUrlRes && signedUrlRes.responseCode === 200) {
      const uploadSuccess = await uploadAudioFile(
        signedUrlRes.response,
        recordedBlobFile
      );
      if (uploadSuccess) {
        return `${S3_BASE_URL}/${signedUrlRes.key}`;
      }
    }
  } catch (error) {
    console.error('Audio upload failed:', error);
  }
  return null;
};
